import { render, staticRenderFns } from "./TagBar.vue?vue&type=template&id=180fe195&scoped=true&"
import script from "./TagBar.vue?vue&type=script&lang=js&"
export * from "./TagBar.vue?vue&type=script&lang=js&"
import style0 from "./TagBar.vue?vue&type=style&index=0&id=180fe195&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180fe195",
  null
  
)

export default component.exports